<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M12 5C4.36704 5 2.07304 11.617 2.05204 11.684L1.94604 12L2.05105 12.316C2.07305 12.383 4.36704 19 12 19C19.633 19 21.927 12.383 21.948 12.316L22.054 12L21.949 11.684C21.927 11.617 19.633 5 12 5ZM12 16C9.79404 16 8.00004 14.206 8.00004 12C8.00004 9.794 9.79404 8 12 8C14.206 8 16 9.794 16 12C16 14.206 14.206 16 12 16Z"
    fill="#8D939A"
  />
  <path
    d="M12 10C10.916 10 10 10.916 10 12C10 13.084 10.916 14 12 14C13.084 14 14 13.084 14 12C14 10.916 13.084 10 12 10Z"
    fill="#8D939A"
  />
</svg>
